import { Component } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { ListaFuncionalidadeComponent } from '../../../shared/components/lista-funcionalidade/lista-funcionalidade.component';

@Component({
  selector: 'app-suporte-home',
  imports: [MenuComponent, ListaFuncionalidadeComponent],
  templateUrl: './suporte-home.component.html',
  styleUrl: './suporte-home.component.css',
})
export class SuporteHomeComponent {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor() {
    this.moduloEnum = ModuloEnum.Suporte;
  }
}
